import { useState } from "react";
import PagedResult from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/PagedResult";
import NotificationService from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";
import { Accomplishment } from "../models/Accomplishment";
import AccomplishmentService from "../services/AccomplishmentService";

enum AccomplishmentStatus {
  ALL = "ALL",
  APPROVED = "APPROVED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

const useAccomplishment = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState<string>(AccomplishmentStatus.ALL);
  const [updateTime, setUpdateTime] = useState(0);

  const getAllPaginated = async (pageNumber: number, count: number): Promise<PagedResult<Accomplishment>> => {
    return AccomplishmentService.getAllAccomplishmentsByStatus(pageNumber, count, statusFilter).then((result) =>
      result.getContentOrThrowError()
    );
  };

  const handleUpdateStatus = (instance: Accomplishment, status: "Approved" | "Pending" | "Rejected") => {
    AccomplishmentService.updateStatus(instance.externalId!, status).then((response) => {
      response.getContentOrNotifyError(() => NotificationService.info("Accomplishment status changed successfully"));
      setUpdateTime(new Date().getTime());
    });
  };

  return { isLoading, statusFilter, setStatusFilter, getAllPaginated, handleUpdateStatus, updateTime };
};
export default useAccomplishment;
